import * as React from 'react';

// Placeholder
import { PageGeneric as PageGenericPlaceholder } from '@shopee-user/placeholder-ui';

// Context
import { RouteLoadingContext } from '@shopee/route-loading-context';

// I18n constants & utils
import { withTranslation } from '@shopee-user/platform';

// patch the generateAsyncRouteComponent to have a default Placeholder
export const generateAsyncRouteComponent = ({
  loader,
  Placeholder = PageGenericPlaceholder,
  i18nCollections = [],
}: {
  loader: () => Promise<any>;
  Placeholder?: React.ComponentType<any>;
  ownProps?: { [key: string]: any };
  i18nCollections?: number[];
}): React.ComponentType<any> => {
  function PlaceholderWithLoading() {
    return (
      <RouteLoadingContext.Provider value={{ showLoadingPlaceholder: true }}>
        <Placeholder />
      </RouteLoadingContext.Provider>
    );
  }

  return withTranslation(
    i18nCollections,
    PlaceholderWithLoading
  )(React.lazy(loader));
};
